import { render, staticRenderFns } from "./Rulebook.vue?vue&type=template&id=03c65d18"
import script from "./Rulebook.vue?vue&type=script&lang=ts"
export * from "./Rulebook.vue?vue&type=script&lang=ts"
import style0 from "./Rulebook.vue?vue&type=style&index=0&id=03c65d18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports